import * as React from 'react';
import {
  Button,
  ButtonSize,
  ButtonVariant,
  ColorVariant,
  Illustration,
  IllustrationIcon,
  IllustrationSize,
  Typography,
  TypographyVariant,
} from '@secretescapes/falcon';
import { i18n } from '@secretescapes/i18n';
import { useTranslations } from '@utils/useTranslations';
import { Countdown } from './Countdown';
import { Box, CountdownWrapper } from './MaintenanceBox.styles';
import { redirectToAllSales } from './MaintenanceBox.utils';

export interface MaintenanceBoxProps {
  className?: string;
  endDate: string;
  isMobile?: boolean;
}

export const MaintenanceBox = ({ className, endDate, isMobile }: MaintenanceBoxProps) => {
  const { translations } = useTranslations();
  const endDateFormated = new Date(endDate);

  return (
    <Box className={className} isMobile={isMobile}>
      <Illustration
        icon={IllustrationIcon.NoConnection}
        size={IllustrationSize.s}
        color={ColorVariant.secondary}
      />
      <CountdownWrapper isMobile={isMobile}>
        <Typography component={'span'} variant={TypographyVariant.body} color={'inherit'}>
          {i18n('providers.outage.text', [], translations)}
        </Typography>{' '}
        <Countdown endDate={endDateFormated} />
      </CountdownWrapper>
      {isMobile ? (
        <Button
          onClick={redirectToAllSales}
          variant={ButtonVariant.primary}
          size={ButtonSize.large}
        >
          {`${i18n('common.viewOursales', [], translations)}`}
        </Button>
      ) : null}
    </Box>
  );
};
